import * as React from 'react';

export interface TErrorBoundaryContext {
  setErrors: (error: Error) => void;
}

export const ErrorBoundaryContext = React.createContext<TErrorBoundaryContext>({
  setErrors: null
});
